// src/ShareDraftModal.tsx
import React, { useState } from 'react';

interface ShareDraftModalProps {
  applicantName: string;
  formData: any;
  onClose: () => void;
}

export const ShareDraftModal: React.FC<ShareDraftModalProps> = ({ applicantName, formData, onClose }) => {
  const [copied, setCopied] = useState(false);

  // Build clickable web URL for QR code scan so phone camera opens current portal route directly
  const currentHash = window.location.hash || '#/india';
  const shareableUrl = `${window.location.origin}${window.location.pathname}${currentHash}`;
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(shareableUrl)}`;

  // Encode text summary for WhatsApp sharing & copy button
  const draftSummary = `📋 *Indian e-Visa Application Draft*\nApplicant: ${applicantName || 'Primary Applicant'}\nNationality: ${formData.nationality || 'Sri Lanka'}\nPurpose: ${formData.visitingIndiaFor || 'Tourist'}\nPassport No: ${formData.passportNumber || 'N/A'}\nLink: ${shareableUrl}\n\nProcessed via mySky Travels Portal.`;

  const encodedMsg = encodeURIComponent(draftSummary);
  const whatsappUrl = `https://wa.me/?text=${encodedMsg}`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(draftSummary);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(15, 23, 42, 0.65)',
        backdropFilter: 'blur(4px)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1rem',
      }}
    >
      <div
        style={{
          background: '#ffffff',
          borderRadius: '16px',
          padding: '2rem',
          maxWidth: '440px',
          width: '100%',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2)',
          textAlign: 'center',
        }}
      >
        <h3 style={{ fontSize: '1.25rem', fontWeight: '800', color: '#0f172a', marginBottom: '0.35rem' }}>
          📲 Share Application Draft
        </h3>
        <p style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '1.25rem' }}>
          Send this draft to <strong>{applicantName}</strong> via WhatsApp or scan the QR Code.
        </p>

        {/* QR Code Container */}
        <div style={{ background: '#f8fafc', padding: '1rem', borderRadius: '12px', display: 'inline-block', marginBottom: '1.25rem', border: '1px solid #e2e8f0' }}>
          <img src={qrCodeUrl} alt="Draft QR Code" style={{ width: '160px', height: '160px', borderRadius: '8px' }} />
          <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.5rem', fontWeight: '600' }}>
            Scan with phone camera to view draft
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: '#25d366',
              color: '#ffffff',
              padding: '0.75rem 1rem',
              borderRadius: '8px',
              fontWeight: '700',
              fontSize: '0.925rem',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              boxShadow: '0 4px 12px rgba(37, 211, 102, 0.25)',
            }}
          >
            💬 Send Draft via WhatsApp
          </a>

          <button
            type="button"
            onClick={handleCopyLink}
            className="btn-secondary"
            style={{ padding: '0.75rem 1rem', fontSize: '0.9rem' }}
          >
            {copied ? '✅ Draft Summary Copied!' : '📋 Copy Draft Details'}
          </button>

          <button
            type="button"
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#64748b',
              fontSize: '0.85rem',
              cursor: 'pointer',
              marginTop: '0.5rem',
              textDecoration: 'underline',
            }}
          >
            Close Window
          </button>
        </div>
      </div>
    </div>
  );
};
